<template>
    <v-dialog v-model="dialog" persistent width="950">
 
      <v-card class="p-0">
        <!-- Cabecera del formulario -->
        <v-card-title class="headline">
          <v-flex xs9>
            <v-icon>done</v-icon>
           Aprobar incremento salarial
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
  
        <!-- Cuerpo del formulario -->
        <v-card-text>
        <v-container grid-list-md style="min-width: 100%">
          <v-layout wrap row>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Gestión: </strong> {{ form.gestion }}
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Fecha de creación: </strong>
                {{ $moment(form.fecha_creacion).format("DD-MM-YYYY") }}
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle" v-if="form.fecha_aprobacion">
                <strong>Fecha de aprobación:</strong>
                {{ $moment(form.fecha_aprobacion).format("DD-MM-YYYY") }}
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Fecha de ejecución:</strong>
                {{ $moment(form.fecha_ejecucion).format("DD-MM-YYYY") }}
              </h3>
            </v-flex>
          </v-layout>
          <h3 class="detalleSubtitulo"><strong>Listado de incrementos salariales</strong></h3>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="incremento_salarial_detalles"
                class="elevation-1"
                :headers="headers_detalles"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.cargo }}
                  </td>
                  <td class="text-xs-center">{{ props.item.porcentaje }}</td>
                  <td class="text-xs-center">
                    {{ props.item.haber_basico_actual }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.haber_basico_incrementado }}
                  </td>
            
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <h3 class="detalleSubtitulo"><strong>Seguimiento de registro</strong></h3>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="seguimientos"
                class="elevation-1"
                :headers="headers_seguimientos"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_registro }}
                  </td>
                  <td class="text-xs-center">{{ props.item.nombres }}</td>
                  <td class="text-xs-center">
                    {{ props.item.estado }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
          <v-card-actions>
            <v-btn color="rgb(66,13,242)" dark @click.native="aprobarIncremento() ">
              <v-icon>done</v-icon> aprobar
            </v-btn>
            <v-btn @click.native="close()">
              <v-icon>cancel</v-icon> CANCELAR
            </v-btn>
          </v-card-actions>

      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

  
  export default {
    // Definición de mixins importados
    mixins: [validate],
    // Variables iniciales
    data() {
      return {
        dialog: false,
        form: {},
        valid: false,
        loading: false,
        lista_cargos: [],
        incremento_salarial_detalles: [],
        id_incremento_salarial: null,
        bandera_id_incremento:false,
        seguimientos: [],
        headers_seguimientos: [
        { text: "Fecha", value: "fecha_registro", align: "center" },
        { text: "Usuario", value: "nombres", align: "center" },
        {
          text: "Estado",
          value: "estado",
          align: "center",
        },
      ],
        headers_detalles: [
          { text: "Cargo", value: "cargo", align: "center" },
          { text: "Porcentage", value: "porcentage", align: "center" },
          {
            text: "Haber básico actual",
            value: "haber_basico_actual",
            align: "center",
          },
          {
            text: "Haber básico incrementado",
            value: "haber_basico_incrementado",
            align: "center",
          },

        ],
      };
    },
    mounted() {
      this.$bus.$on(
        "openDialogAprobarIncremento",
        async (item) => {
          this.form = item;
          await this.cargarIncrementoSalarialDetalle(this.form.id_incremento); 
          await this.cargarSeguimiento();      
          this.dialog = true;
       
        }
      );
    },
    methods: {
      close() {
        this.form = {};
        this.loading = false;
        this.incremento_salarial_detalles = [];
        this.valid = false;
        this.$bus.$emit("closeDialogAprobarIncremento");
        this.dialog = false;
      },
      async cargarSeguimiento() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
				query {
					runQuery(consulta:"select * from movilidad.v_seguimiento_incremento_salarial vs where vs.id_estado <> 2 and vs.id_incremento_salarial=${parseInt(this.form.id_incremento)}"){
						respuesta
					}
					}
				`,
        });
        this.seguimientos = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
      async aprobarIncremento() {
        try {
            this.$confirm('Desea aprobar el incremento?', async() => {
              let usuario=this.$storage.get("user");
              let respuesta = await this.$service.graphql({
                query: `
                            query{
                              runQuery(consulta:"select movilidad.fn_aprobar_incremento_salarial(${parseInt(this.form.id_incremento)},${usuario.id})"){
                              respuesta
                              }
                            }
                          `,
              });
              respuesta =
                respuesta.runQuery.respuesta[0].fn_aprobar_incremento_salarial;
              let resps = respuesta.split("|");
              if (resps[0]=="1") {
                  this.$message.info("El incremento salarial fué aprobado exitosamente");
                  this.close()
              }else{
                this.$message.error(resps[1]);
              }
          });
        } catch (error) {
            console.log(error)
        }
      },

      async cargarIncrementoSalarialDetalle(id) {
        try {
          this.incremento_salarial_detalles = [];
          let respuesta = await this.$service.graphql({
            query: `
                  query {
                      runQuery(consulta:"select * from movilidad.v_incremento_salarial_detalle vis where vis.id_incremento_salarial=${parseInt(
              id
            )} and vis.id_estado_incremento_salarial_detalle<>2"){
                          respuesta
                      }
                      }
                  `,
          });
          this.incremento_salarial_detalles = respuesta.runQuery.respuesta;
       
        } catch (error) {
          console.log(error);
        }
      },

    },
    components: {

    },
  };
  </script>
  
  <style>
  .detalle {
  font-size: 1.07em;
  color: rgb(24, 22, 134);
}
.detalleSubtitulo {
  font-size: 1.45em;
  color: rgb(24, 22, 134);
}
  </style>
  


// WEBPACK FOOTER //
// src/components/admin/incremento_salarial/dialogs/AprobarIncrementoSalarial.vue